"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserverAsStream = exports.useResizeObserver = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var resize_observer_1 = require("resize-observer");
var rxjs_1 = require("../rxjs");
var rect_size_1 = require("../types/record/rect-size");
var useResizeObserverCore = function (setRootRectSize) {
    var rootResizeObserver = (0, react_1.useMemo)(function () {
        return new resize_observer_1.ResizeObserver(function (entries) {
            if (entries.length >= 1) {
                var contentRect = entries[0].contentRect;
                setRootRectSize((0, rect_size_1.IRectSize)({
                    width: contentRect.width,
                    height: contentRect.height
                }));
            }
        });
    }, [setRootRectSize]);
    var targetElRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var el = targetElRef.current;
        if (el !== null) {
            rootResizeObserver.observe(el);
        }
        return function () {
            if (el !== null) {
                rootResizeObserver.unobserve(el);
            }
            rootResizeObserver.disconnect();
        };
    }, [targetElRef, rootResizeObserver]);
    return targetElRef;
};
var useResizeObserver = function () {
    var _a = tslib_1.__read((0, react_1.useState)((0, rect_size_1.IRectSize)()), 2), rootRectSize = _a[0], setRootRectSize = _a[1];
    var targetElRef = useResizeObserverCore(setRootRectSize);
    return [rootRectSize, targetElRef];
};
exports.useResizeObserver = useResizeObserver;
var useResizeObserverAsStream = function () {
    var _a = tslib_1.__read((0, rxjs_1.useStateAsStream)((0, rect_size_1.IRectSize)()), 2), 
    // dummy comment to control prettier
    rootRectSize$ = _a[0], setRootRectSize = _a[1];
    var targetElRef = useResizeObserverCore(setRootRectSize);
    return [rootRectSize$, targetElRef];
};
exports.useResizeObserverAsStream = useResizeObserverAsStream;
